import React from "react";
import Tabs from "../navigation/Tabs";
import { useParams } from "react-router-dom";
import ProfileInformation from "./ProfileInformation";
import { LockOpenOutlined, Person2Outlined } from "@mui/icons-material";
import ProfileCredentials from "./ProfileCredentials";

function Profile() {
    const { tab } = useParams();

    return (
        <React.Fragment>
            <Tabs
                title={"Profile"}
                tabs={
                    [
                        { 
                            title: "User Information",
                            icon: <Person2Outlined />,
                            href: "/profile/information",
                            active: tab === "information",
                            content: (
                                <ProfileInformation />
                            )
                        },
                        { 
                            title: "Credentials",
                            icon: <LockOpenOutlined />,
                            href: "/profile/credentials",
                            active: tab === "credentials",
                            content: (
                                <ProfileCredentials />
                            )
                        }
                    ]
                }
            />
        </React.Fragment>
    );
}

export default Profile;